const collapsibleFooter = () => {
  const headings = document.querySelectorAll('.footer-block__heading');
  headings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      const detailsContent = heading.nextElementSibling;
      if (detailsContent && detailsContent.classList.contains('footer-block__details-content')) {
        if (heading.classList.contains('active')) {
          detailsContent.style.display = 'none';
          heading.classList.remove('active');
        } else {
          detailsContent.style.display = 'block';
          heading.classList.add('active');
        }
      }
    });
  });
};
document.addEventListener('DOMContentLoaded', collapsibleFooter());
